/**
 * Tueftler — Walnuss: gefurchte Nuss-Haelften, Kupfer-Tech
 * STUB (BATTLE-17) — wird vom Spezies-Agent ersetzt. Contract: types.ts.
 */
import type { PaintParams, SpeciesPainter } from './types'
import { rimLight, specular, volumeGradient } from '../draw3d'

export const paintWalnuss: SpeciesPainter = (p: PaintParams) => {
  const { ctx, x, y, r, colors } = p
  ctx.save()
  ctx.lineWidth = Math.max(2, r * 0.12)
  ctx.strokeStyle = colors.outline
  ctx.fillStyle = volumeGradient(ctx, x, y, r, colors.body)
  ctx.beginPath()
  ctx.ellipse(x, y, r * 0.85, r * 0.95, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.stroke()
  if (p.emotion !== 'dead') {
    rimLight(ctx, x, y, r * 0.85, r * 0.95)
    specular(ctx, x - r * 0.28, y - r * 0.38, r * 0.14)
  }
  ctx.restore()
}
